import React, { PureComponent } from 'react'
import { bool, func } from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Button from '@active/react-ui/Button'
import { getRootElement } from '../../../../shared/utils/poperConfig'
import I18nMessage from '../../../common/I18nMessage'

class ReagreeWaiverConfirm extends PureComponent {
  static propTypes = {
    isReagreeWaiverConfirmShow: bool.isRequired,
    handleReagreeWaiverConfirmClose: func.isRequired,
    handleCancel: func.isRequired,
  }

  componentDidMount() {
    setTimeout(() => {
      const focusElement = getRootElement().querySelector('.reagree-waiver__confirm-modal .cancel-btn')

      if (focusElement) {
        focusElement.focus && focusElement.focus()
      }
    }, 500)
  }

  render() {
    const {
      isReagreeWaiverConfirmShow, handleCancel,
      handleReagreeWaiverConfirmClose,
    } = this.props

    return (
      <Modal
        shown={isReagreeWaiverConfirmShow}
        onClose={handleReagreeWaiverConfirmClose}
        className="passport-ui-app__modal reagree-waiver__confirm-modal passport-content"
      >
        <ModalBody>
          <div className="passport-ui-app__subTitle">
            <I18nMessage id="passport.waiver.terms.acceptTermsClose" />
          </div>
          <div className="passport__pt20 passport__pb10 make-sure-close">
            <I18nMessage id="passport.waiver.terms.makeSureClose" />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="passport-content-footer">
            <Button className="cancel-btn" onClick={handleCancel} type="super">
              <I18nMessage id="passport.common.btn.cancel" />
            </Button>
            <Button className="btn-primary btn-close" type="secondary" onClick={handleReagreeWaiverConfirmClose}>
              <I18nMessage id="passport.common.btn.close" />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ReagreeWaiverConfirm
